import { AdacIdentityModelApi } from '../../generated/ModelsAdacIdentityModelApi';
import { IUserExtApi } from '../../generated/InterfacesIUserExtApi';
import { ContractApi } from '../../generated/PersonContractApi';

export class User extends AdacIdentityModelApi {
	private token: string;

	constructor(initialProperties?: Partial<User>) {
		super(initialProperties);
		if (!this.userData) {
			this.userData = new IUserExtApi();
		}
		if (!this.roles) {
			this.roles = [];
		}
		if (initialProperties && initialProperties.Token) {
			this.token = initialProperties.Token;
		}
	}

	/**
	 * @return true, if the user is a customer (Nicht-Mitglied).
	 * 					 false, if the user has a membership.
	 */
	get Customer(): boolean {
		let result: boolean = this.Valid;
		if (result) {
			result = this.hasMembershipData() && this.userData.Mitgliedschaft.Vertragskunde;
			if (!result) {
				result = !this.Member;
			}
		}
		return result;
	}

	/**
	 * @return true, if the user has a membership.
	 * 					 false, if the user is a customer (Nicht-Mitglied).
	 */
	get Member(): boolean {
		// hint: Mock user is treated as a "Mitglied" user
		return this.ValidMember || this.NewMember || this.hasRole('Mockup');
	}

	get ValidMember(): boolean {
		return this.Valid && this.hasMembershipData() && this.userData.IstMitglied;
	}

	/**
	 * @return true, if the user just got a new membership by completing the mgl enclosure.
	 * 					 false otherwise.
	 */
	get NewMember(): boolean {
		return this.hasRole('Neues Mitglied');
	}

	/**
	 * @return true, if the user has a basis membership.
	 * 					 false otherwise.
	 */
	get BasisMember(): boolean {
		return this.Valid && this.hasMembershipData() && !(this.userData.Mitgliedschaft.PlusMitglied);
	}

	/**
	 * @return true, if the user has a plus membership.
	 * 					 false otherwise.
	 */
	get PlusMember(): boolean {
		return this.Valid && this.hasMembershipData() && this.userData.Mitgliedschaft.PlusMitglied;
	}

	/**
	 * @return true, if the user has a premium membership.
	 * 					 false otherwise.
	 */
	get PremiumMember(): boolean {
		return this.Valid && this.hasMembershipData() && this.userData.Mitgliedschaft.PremiumMitglied;
	}

	get Verified(): boolean {
		return this.hasRole("Verified");
	}

	get Guest(): boolean {
		return this.hasRole("Gast") && this.Valid && this.hasMembershipData();
	}

	/**
	 * @return true, if the user object holds user data.
	 * 					 false, if the user object is empty.
	 */
	get Valid(): boolean {
		return !!this.mglNo;
	}

	/**
	 * MglToken if user completed the 1-stufige Mitgliedschaft before.
	 */
	get Token(): string {
		return this.token;
	}

	/**
	 * MglToken if user completed the 1-stufige Mitgliedschaft before.
	 */
	set Token(value: string) {
		this.token = value;
	}

	get Mitarbeiter(): boolean {
		return this.hasMembershipData() && this.userData.Mitgliedschaft.Mitarbeiter;
	}

	set Mitarbeiter(value) {
		if (!this.userData) {
			this.userData = new IUserExtApi();
		}
		if (!this.userData.Mitgliedschaft) {
			this.userData.Mitgliedschaft = new ContractApi();
		}
		this.userData.Mitgliedschaft.Mitarbeiter = value;
	}

	get Partner(): boolean {
		return this.hasMembershipData() && this.userData.Mitgliedschaft.Partner;
	}

	set Partner(value: boolean) {
		if (!this.userData) {
			this.userData = new IUserExtApi();
		}
		if (!this.userData.Mitgliedschaft) {
			this.userData.Mitgliedschaft = new ContractApi();
		}
		this.userData.Mitgliedschaft.Partner = value;
	}

	public hasRole(role: string): boolean {
		if (!this.roles) {
			return false;
		}
		return $.inArray(role, this.roles) > -1;
	}

	private hasMembershipData(): boolean {
		return (this.userData && this.userData.Mitgliedschaft) ? true : false; //NOSONAR
	}

	public hasChangePermissions(): boolean {
		if (this.hasMembershipData()) {
			return !(
				this.userData.Mitgliedschaft.FamilienMitglied ||
				this.userData.Mitgliedschaft.KeineTarifAenderung ||
				this.userData.Mitgliedschaft.KeineTarifAenderungOnline ||
				this.userData.Mitgliedschaft.YoungGenerationTarif
			);
		}
		return false;
	}

	/**
	 * Creates a new model object and copies the values from the provided data object (or other application model) to the created model.
	 */
	public static createFromObject(dataObject: { [key: string]: any }): User {
		const result = new User(AdacIdentityModelApi.createFromObject(dataObject));
		if (dataObject && (dataObject.token || dataObject.Token)) {
			result.Token = dataObject.token || dataObject.Token;
		}
		return result;
	}
}
